import ArrowRightIcon from '../_assets/icons/arrowRight.svg';
import ArticleIcon from '../_assets/icons/article.svg';
import CalendarIcon from '../_assets/icons/calendar.svg';
import ForumIcon from '../_assets/icons/forum.svg';
import GroupsIcon from '../_assets/icons/groups.svg';
import HeadsetIcon from '../_assets/icons/headset.svg';
import InfoIcon from '../_assets/icons/info.svg';
import MinusCircleIcon from '../_assets/icons/minusCircle.svg';
import PlayIcon from '../_assets/icons/play.svg';
import PlusCircleIcon from '../_assets/icons/plusCircle.svg';
import PDFIcon from '../_assets/icons/pdf.svg';
import RocketIcon from '../_assets/icons/rocket.svg';
import SparkleIcon from '../_assets/icons/sparkle.svg';
import MailIcon from '../_assets/icons/envelopeSimple.svg';

export const limitedIconSelectionValues = ['arrowRight', 'plusCircle', 'pdf'] as const;
export type LimitedIconSelectionProps = {
	icon: (typeof limitedIconSelectionValues)[number];
};

export const iconSelectionValues = [
	'calendar',
	'document',
	'forum',
	'groups',
	'headset',
	'info',
	'minusCircle',
	'play',
	'plusCircle',
	'pdf',
	'rocket',
	'sparkle',
	'mail',
] as const;
export type IconSelectionProps = {
	icon: (typeof iconSelectionValues)[number];
};

export function iconSelectionToPhosphorus(icon: string) {
	switch (icon) {
		case 'document':
			return 'file';
		case 'forum':
			return 'chats';
		case 'groups':
			return 'users-three';
		case 'pdf':
			return 'file-pdf';
		default:
			return icon;
	}
}

export function LimitedIconSelection({ icon }: LimitedIconSelectionProps) {
	switch (icon) {
		case 'arrowRight':
			return <ArrowRightIcon />;
		case 'plusCircle':
			return <PlusCircleIcon />;
		case 'pdf':
			return <PDFIcon />;
		default:
			return undefined;
	}
}

export function IconSelection({ icon }: IconSelectionProps) {
	switch (icon) {
		case 'calendar':
			return <CalendarIcon />;
		case 'document':
			return <ArticleIcon />;
		case 'forum':
			return <ForumIcon />;
		case 'groups':
			return <GroupsIcon />;
		case 'headset':
			return <HeadsetIcon />;
		case 'info':
			return <InfoIcon />;
		case 'minusCircle':
			return <MinusCircleIcon />;
		case 'play':
			return <PlayIcon />;
		case 'plusCircle':
			return <PlusCircleIcon />;
		case 'pdf':
			return <PDFIcon />;
		case 'rocket':
			return <RocketIcon />;
		case 'sparkle':
			return <SparkleIcon />;
		case 'mail':
			return <MailIcon />;
		default:
			return undefined;
	}
}
